import React from 'react';
import { BattenteTriangleFill } from './primitives';

// Porte interne: wooden leaf (no glass), opening symbol in blue like the windows.
const LEAF = '#E9DCC6';
const LEAF_LINE = '#B9A584';
const WALL = '#E2E8F0';
const BLUE = '#0055CC';

const Leaf = ({ x, y, w, h, dashed = false }) => (
  <g>
    <rect x={x} y={y} width={w} height={h} fill={dashed ? 'none' : LEAF} stroke={dashed ? '#888' : '#333'} strokeWidth="1" strokeDasharray={dashed ? '3,2' : undefined} />
    {!dashed && <rect x={x + w * 0.18} y={y + h * 0.08} width={w * 0.64} height={h * 0.84} fill="none" stroke={LEAF_LINE} strokeWidth="1" />}
  </g>
);

const Knob = ({ x, y }) => <rect x={x - 2} y={y - 6} width={4} height={12} rx={1} fill="#6B6B6B" />;

const Arrow = ({ x1, x2, y }) => {
  const dir = x2 > x1 ? 1 : -1;
  return (
    <g stroke={BLUE} strokeWidth="1.4" fill="none">
      <line x1={x1} y1={y} x2={x2} y2={y} />
      <line x1={x2 - 5 * dir} y1={y - 4} x2={x2} y2={y} />
      <line x1={x2 - 5 * dir} y1={y + 4} x2={x2} y2={y} />
    </g>
  );
};

// Battente: one leaf, hinges on the left
export const interiorDoorHinged = () => (
  <svg viewBox="0 0 70 120" className="w-full h-full">
    <Leaf x={8} y={8} w={54} h={108} />
    <BattenteTriangleFill x={10} y={10} w={50} h={104} side="left" color={BLUE} />
    <Knob x={55} y={64} />
    <path d="M4 118 V4 H66 V118" fill="none" stroke="#222" strokeWidth="2.5" />
  </svg>
);

// Battente a due ante: hinges on both sides, meeting in the middle
export const interiorDoorDouble = () => (
  <svg viewBox="0 0 110 120" className="w-full h-full">
    <Leaf x={8} y={8} w={46} h={108} />
    <Leaf x={56} y={8} w={46} h={108} />
    <BattenteTriangleFill x={10} y={10} w={42} h={104} side="left" color={BLUE} />
    <BattenteTriangleFill x={58} y={10} w={42} h={104} side="right" color={BLUE} />
    <Knob x={49} y={64} />
    <Knob x={61} y={64} />
    <path d="M4 118 V4 H106 V118" fill="none" stroke="#222" strokeWidth="2.5" />
  </svg>
);

// Scorrevole interno muro (a scomparsa): the leaf slides into a pocket inside the wall
export const interiorDoorPocket = () => (
  <svg viewBox="0 0 110 120" className="w-full h-full">
    <rect x={2} y={2} width={48} height={116} fill={WALL} />
    <rect x={6} y={8} width={44} height={108} fill="none" stroke="#888" strokeWidth="1" strokeDasharray="3,2" />
    <Leaf x={30} y={8} w={72} h={108} />
    <Arrow x1={78} x2={40} y={64} />
    <path d="M50 118 V4 H106 V118" fill="none" stroke="#222" strokeWidth="2.5" />
    <line x1={2} y1={4} x2={50} y2={4} stroke="#888" strokeWidth="1" />
  </svg>
);

// Scorrevole esterno muro: the leaf runs on a rail in front of the wall
export const interiorDoorSlidingWall = () => (
  <svg viewBox="0 0 120 120" className="w-full h-full">
    <rect x={2} y={10} width={116} height={108} fill={WALL} />
    <path d="M60 118 V14 H112 V118" fill="none" stroke="#888" strokeWidth="1" strokeDasharray="3,2" />
    <rect x={4} y={4} width={112} height={4} rx={1} fill="#555" />
    <Leaf x={14} y={10} w={58} h={106} />
    <Knob x={66} y={64} />
    <Arrow x1={32} x2={60} y={64} />
  </svg>
);

// A libro: the leaf folds in two panels
export const interiorDoorFolding = () => (
  <svg viewBox="0 0 70 120" className="w-full h-full">
    <Leaf x={8} y={8} w={27} h={108} />
    <Leaf x={35} y={8} w={27} h={108} />
    <line x1={35} y1={20} x2={35} y2={104} stroke={BLUE} strokeWidth="1" strokeDasharray="4,3" />
    <polyline points="12,14 35,22 58,14" fill="none" stroke={BLUE} strokeWidth="1.2" />
    <Knob x={56} y={64} />
    <path d="M4 118 V4 H66 V118" fill="none" stroke="#222" strokeWidth="2.5" />
  </svg>
);
